import React from 'react';
import {useParams} from 'react-router-dom';
import {CreditCardIcon} from '@heroicons/react/24/outline';
import {useMe} from 'hooks';

import BillingHeader from './Billing.Header';

interface IBillingPaymentCardsProps {}

const BillingPaymentCards = ({}: IBillingPaymentCardsProps) => {
  const params = useParams();
  const workspace = params.workspace ?? '';

  const me = useMe();
  const paymentCard = me?.paymentCard;

  const text = (() => {
    const ending = paymentCard?.ending;
    return ending ? `**** ${ending}` : 'None';
  })();

  return (
    <BillingHeader
      icon={CreditCardIcon}
      name="Payment Card"
      text={text}
      buttonText="Manage cards"
      buttonUrl={`/${workspace}/billing/payment-cards`}
    />
  );
};

export default React.memo(BillingPaymentCards);
